import { useEffect, type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { toast } from 'sonner'
import { useAuth } from '@/lib/auth'
import { useProfile } from '@/lib/hooks/use-profile'
import { Spinner } from '@/components/ui/spinner'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading, configured, signOut } = useAuth()
  const location = useLocation()
  const profileQuery = useProfile()

  // Nhân viên bị vô hiệu hoá (is_active=false) → đăng xuất ngay. Backend cũng đã
  // ban ở tầng Auth (token không refresh/mint được nữa); đây là chốt phía client
  // cho session đang mở (profile refetch theo staleTime 30s + khi focus lại tab).
  const inactive = profileQuery.data?.is_active === false
  useEffect(() => {
    if (inactive) {
      void signOut()
      toast.error('Tài khoản đã bị vô hiệu hoá. Liên hệ quản trị viên.')
    }
  }, [inactive, signOut])

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner size="lg" label="Đang xác thực..." />
      </div>
    )
  }

  if (!configured) {
    return <Navigate to="/setup" replace />
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (inactive) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
